function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3572 4.28571H17.4286V5.89286H16.3572V4.28571Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2142 4.28571H15.2857V5.89286H14.2142V4.28571Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2858 6.96429H18.5001V9.10714H15.2858V6.96429Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 11.2499C19.3457 11.2495 20.1791 11.0475 20.9311 10.6606C20.3506 10.3412 19.6982 10.1753 19.0357 10.1784H14.75C14.2548 10.171 13.7632 10.2619 13.3034 10.4458C12.8436 10.6298 12.4249 10.903 12.0714 11.2499H18.5Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.3928 2.14286H-1.85718V3.21429H25.9084C25.7972 2.90116 25.5918 2.6301 25.3205 2.43828C25.0491 2.24645 24.7251 2.14327 24.3928 2.14286Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.072 4.82143C12.0638 4.96429 12.0858 5.10727 12.1367 5.241C12.1877 5.37473 12.2663 5.49617 12.3675 5.59736C12.4687 5.69854 12.5901 5.77718 12.7239 5.82811C12.8576 5.87904 13.0006 5.9011 13.1434 5.89285V4.28571H12.072V4.82143Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0714 0H21.7143V1.07143H12.0714V0Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 4.28571H19.5714V5.89286H18.5V4.28571Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8572 21.9643H26V26.25H23.8572V21.9643Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.9061 6.42857C24.7698 8.03443 24.0361 9.53076 22.85 10.6219C21.6639 11.7129 20.1116 12.3194 18.5 12.3214H10.4643C8.61724 12.3214 6.84585 13.0552 5.53979 14.3612C4.23373 15.6673 3.5 17.4387 3.5 19.2857C3.5 21.1328 4.23373 22.9042 5.53979 24.2102C6.84585 25.5163 8.61724 26.25 10.4643 26.25H22.7857V25.1786H10.4643C8.9014 25.1786 7.40253 24.5577 6.29741 23.4526C5.19228 22.3475 4.57143 20.8486 4.57143 19.2857C4.57143 17.7228 5.19228 16.224 6.29741 15.1188C7.40253 14.0137 8.9014 13.3929 10.4643 13.3929H18.5C20.3958 13.3906 22.2205 12.6714 23.6081 11.3797C24.9957 10.088 25.8435 8.31932 25.9812 6.42857H24.9061Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.9286 4.28571H26V5.35714H24.9286V4.28571Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 14.464H11V24.1069H22.7857V13.9283C22.7846 13.7289 22.7691 13.5298 22.7391 13.3326C21.4493 14.074 19.9877 14.4641 18.5 14.464ZM20.6429 21.4283C20.6429 21.5704 20.5864 21.7066 20.486 21.8071C20.3855 21.9076 20.2492 21.964 20.1071 21.964H13.6786C13.5365 21.964 13.4002 21.9076 13.2998 21.8071C13.1993 21.7066 13.1429 21.5704 13.1429 21.4283V17.1426C13.1429 17.0005 13.1993 16.8642 13.2998 16.7638C13.4002 16.6633 13.5365 16.6069 13.6786 16.6069H20.1071C20.2492 16.6069 20.3855 16.6633 20.486 16.7638C20.5864 16.8642 20.6429 17.0005 20.6429 17.1426V21.4283Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.7857 28.9286V27.3214H11V28.9286C11 29.2127 11.1129 29.4853 11.3138 29.6862C11.5147 29.8871 11.7873 30 12.0714 30H21.7143C21.9984 30 22.271 29.8871 22.4719 29.6862C22.6728 29.4853 22.7857 29.2127 22.7857 28.9286Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2142 20.8929H19.5714V17.6786H14.2142V20.8929ZM15.2857 18.75H18.4999V19.8214H15.2857V18.75Z",
  fill: "#1442A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7143 4.82143V4.28571H20.6428V5.89285C20.7857 5.9011 20.9287 5.87904 21.0624 5.82811C21.1961 5.77718 21.3176 5.69854 21.4188 5.59736C21.5199 5.49617 21.5986 5.37473 21.6495 5.241C21.7004 5.10727 21.7225 4.96429 21.7143 4.82143Z",
  fill: "#1442A8"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white"
})));

var SvgDisinsection = function SvgDisinsection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisinsection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disinsection.3616dec8.svg";
export { ForwardRef as ReactComponent };